import {Injectable,  Component, ViewChild, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableModule, MatTableDataSource } from "@angular/material/table";
import { SectoresOrganizacionalesService } from 'src/app/services/sectores-organizacionales.service';
import { SectoresOrganizacionalesComponent } from '../sectores-organizacionales/sectores-organizacionales.component';
import { element } from 'protractor';
import {MatSort} from '@angular/material/sort';
export interface Estandard{
  id?:number;
  cdEstandarCompetencia?:string;
  nbTituloEc?:string;
  dsEstandarCompetencia?:string;
  nivel?: number;
  sector?: string;
  comite?: string;
}

let DATA : Estandard[] = [];
let _DATA : Estandard[] = [];

@Component({
  selector: 'app-sectores-organizacionales-tabla-est',
  templateUrl: './sectores-organizacionales-tabla-est.component.html',
  styleUrls: ['./sectores-organizacionales-tabla-est.component.css']
})

export class SectoresOrganizacionalesTablaEstComponent implements OnInit {
  [x: string]: any;
  displayedColumns: string[] = ['cdEstandarCompetencia','nivel', 'nbTituloEc', 'comite', 'sector'];
  constructor(private service: SectoresOrganizacionalesService) {
    this.detalle = true; 
  }
  ngOnInit(): void {
    this.pageSize = 30;
    this.getEstandaresByNivel();    
  }
  @Input() hijo: number;
  @Input() padre: number;
  @Input() title: string;
  @Input() pageSize: number;
  @Output() backTo = new EventEmitter<number>();
  @Output() itemSelected = new EventEmitter<any>();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  index = 0;

  dataSource: MatTableDataSource<any>;
  
  async getEstandaresByNivel() {
    try {      
      _DATA = [];
      DATA = await this.service.getEstandaresById(this.hijo);    
      DATA.forEach(function (estandar){
        estandar["children"].forEach(function (std){
          _DATA.push(std);
        })
      });
      _DATA.sort((a, b) => {
        const nameA = a.cdEstandarCompetencia.toUpperCase(); // ignore upper and lowercase
        const nameB = b.cdEstandarCompetencia.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
      
        // names must be equal
        return 0;
      });
      //this.dataSource = new MatTableDataSource(_DATA); 
      this.dataSource = new MatTableDataSource<any>(_DATA);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    } catch (error) {
      console.log(error);
    }
  }

  detalleByEst(element){
    if(element.id){
      let json = {
        element: element,
        padre: this.hijo,
        lastTitle: this.title
      };
      this.itemSelected.emit(json);
    }
  }
  

  back() {
    let flags: any = {
      nivel: false,
      ocupacion: true,
      sector: false,
      estandar: false
    };
    this.backTo.emit(flags);
  }

  home() {
    window.location.reload();
    }

    applyFilter(event: Event) {
      const filterValue = (event.target as HTMLInputElement).value;
      this.dataSource.filter = filterValue.trim().toLowerCase();
    }
  
}
